module.exports = __webpack_public_path__ + "static/media/angelhack-4-logo2-3.938fde1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/angelhack-4-logo2-3.jpg
// module id = 1064
// module chunks = 0